import { useEffect, useMemo, useState } from "react";
import LoadingCircle from "../utility/LoadingCircle";

export const AcquireAccurateLocationModal = ({ getLocation, onSuccess, onFail }) => {
	const MAX_ATTEMPTS = 5;
	const [attempts, setAttempts] = useState(0);

	const progressPct = useMemo(() => {
		if (!MAX_ATTEMPTS) return 0;
		return Math.min(100, Math.round((attempts / MAX_ATTEMPTS) * 100));
	}, [attempts, MAX_ATTEMPTS]);

	useEffect(() => {
		let cancelled = false;

		const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

		const run = async () => {
			let best = null;

			for (let i = 0; i < MAX_ATTEMPTS; i++) {
				if (!cancelled) setAttempts(i + 1);

				const data = await getLocation();
				if (cancelled) return;

				if (data) {
					if (!best || best.accuracy > data.accuracy) {
						best = data;
					}
				}

				await sleep(1000);
			}

			if (!cancelled && best) {
				onSuccess(best);
			} else {
				onFail();
			}
		};

		run();

		return () => {
			cancelled = true;
		};
	}, [getLocation, onFail, onSuccess]);

	return (
		<div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 z-[220] flex flex-col justify-center items-center p-3">
			<div className="bg-white flex flex-col justify-center items-center rounded-lg shadow-lg text-center p-4">
				<p>Acquiring location...</p>
				<div className="w-full bg-gray-100 rounded-full h-3 overflow-hidden shadow-inner mt-5">
					<div
						className="h-full rounded-full transition-[width] duration-500 ease-out bg-blue-500"
						style={{
							width: `${progressPct}%`,
						}}
					/>
				</div>
			</div>
		</div>
	);
};
